import { styled } from "@mui/material";

export const Wrapper = styled("div")({
  position: "relative",
  minWidth: "200px",
  backgroundColor: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: "5px",
  userSelect: "none",
  boxSizing: "border-box",
});

export const Toggle = styled("button")({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "6px 10px",
  background: "transparent",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  textAlign: "left",
  font: "inherit",
  color: "inherit",
  "&:focus-visible": {
    outline: "2px solid #1d7f7a",
    outlineOffset: "2px",
  },
});

export const Popup = styled("div")<{ menuPlacement?: "left" | "right" }>(
  ({ menuPlacement = "left" }) => ({
    position: "absolute",
    top: "35px",
    left: menuPlacement === "right" ? "auto" : "0",
    right: menuPlacement === "right" ? "0" : "auto",
    zIndex: 99999,
    width: "460px",
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#ffffff",
    border: "1px solid #eeeeee",
    borderRadius: "5px",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.2)",
    "& *": {
      boxSizing: "border-box",
    },
    "@media (max-width: 425px)": {
      width: "100%",
      flexDirection: "column",
    },
  })
);

export const Presets = styled("div")({
  flex: "0 0 50%",
  padding: "20px",
  borderRight: "1px solid #eeeeee",
  "@media (max-width: 425px)": {
    borderRight: "none",
    borderBottom: "1px solid #eeeeee",
  },
});

export const Calendar = styled("div")({
  flex: 1,
  padding: "20px",
});

export const SectionTitle = styled("div")({
  marginBottom: "20px",
  color: "#575757",
  fontSize: "0.75rem",
  fontWeight: 600,
  textTransform: "uppercase",
  userSelect: "none",
});

export const PresetButton = styled("button")({
  display: "block",
  padding: 0,
  margin: 0,
  border: "none",
  background: "none",
  font: "inherit",
  fontWeight: 700,
  color: "inherit",
  cursor: "pointer",
  textAlign: "left",
  "&:focus-visible": {
    outline: "2px solid #1d7f7a",
    outlineOffset: "2px",
  },
  "& + &": {
    marginTop: "8px",
  },
});

export const CalendarHeader = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
});

export const Year = styled("div")({
  userSelect: "none",
});

export const NavButton = styled("button")({
  width: "20px",
  height: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  border: "none",
  background: "transparent",
  color: "inherit",
  cursor: "pointer",
  transition: "opacity 0.2s ease",
  "&:hover": {
    opacity: 0.7,
  },
  "&:focus-visible": {
    outline: "2px solid #1d7f7a",
    outlineOffset: "2px",
  },
  "&.disabled": {
    opacity: 0.2,
    cursor: "default",
    pointerEvents: "none",
  },
});

export const MonthGrid = styled("div")({
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: "5px",
  marginTop: "10px",
});

export const MonthButton = styled("button")<{ isSelected?: boolean; highlightCol?: string }>(
  ({ isSelected, highlightCol = "#1d7f7a" }) => ({
    width: "100%",
    padding: "5px",
    border: `1px solid ${isSelected ? highlightCol : "#eeeeee"}`,
    borderRadius: "5px",
    backgroundColor: isSelected ? highlightCol : "#ffffff",
    textAlign: "center",
    cursor: "pointer",
    font: "inherit",
    color: isSelected ? "#ffffff" : "inherit",
    transition: "box-shadow 0.2s ease, background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.2)",
    },
    "&:focus-visible": {
      outline: "2px solid #1d7f7a",
      outlineOffset: "2px",
    },
    "&.disabled": {
      pointerEvents: "none",
      opacity: 0.5,
      cursor: "default",
    },
  })
);
